import { BaseMessageInfo } from "./BaseMessageInfo";

export class MessageInfoShow
{
    constructor(data: MessageInfoShow = null) {
        Object.assign(this, data);
        if (data !== null) {
            this.messageInfo = new BaseMessageInfo(data.messageInfo);
        }
    }
    message: string;
    title: string;
    code: string;
    data: any;
    messageInfo: BaseMessageInfo;
}
